import React from 'react'
import { Modal } from 'react-bootstrap'


export default class Overview extends React.Component {
    render() {
        const { changeHandler, saveHandler, Model,  cancelHandler, Mode, setShow, setShowDel,cancelHandlerDel,saveHandlerDel,handleValidation,errors} = this.props
        return (
            <div class="mb-10" class="container-lg">

                <Modal show={setShow} onHide={cancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>{Mode}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div class="mb-3">

                            <label for="name" class="form-label">Name*</label>
                            <input type="text" class="form-control" id="name" value={Model.name} onChange={changeHandler("name")} />
                            <span className="error">{errors["name"]}</span>
                        </div>
                        <div class="mb-3">

                            <label for="va_code" class="form-label">VA Code*</label>
                            <input type="number" class="form-control" id="va_code" value={Model.va_code} onChange={changeHandler("va_code")} />
                            <span className="error">{errors["va_code"]}</span>
                        </div>

                        <p style={{fontStyle:"italic"}}>*Wajib Diisi</p>
                    </Modal.Body>

                    <Modal.Footer>
                        <div>
                            <button type="button" class="btn btn-danger" onClick={cancelHandler}>Batal</button>
                            <button type="button" class="btn btn-outline-primary ml-2" onClick={saveHandler}>Simpan</button>
                        </div>
                    </Modal.Footer>
                </Modal>


                <Modal show={setShowDel} onHide={cancelHandlerDel}>
                    <Modal.Header closeButton>
                        <Modal.Title>{Mode}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div class="mb-3">
                            <p>Yakin hapus {Model.name}?</p>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <div>
                            <button type="button" class="btn btn-danger" onClick={cancelHandlerDel}>No</button>
                            <button type="button" class="btn btn-outline-primary ml-2" onClick={saveHandlerDel}>Yes</button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>

        )
    }

}